// Centralised content — French. Front-only. No backend.
// Prices are marked as "indicatifs" and easy to edit here.

import { GOOGLE_MAPS_URL } from "@/lib/site";

export const CONTACT = {
    name: "Joëlle Berthaud",
    role: "Réflexologue certifiée",
    phone: "06 63 34 03 97",
    phoneRaw: "+33663340397",
    email: "joelleberthaud@reflexologue-savoie.com",
    address: {
        street: "1981 Route Royale",
        zip: "73190",
        city: "Challes-les-Eaux",
        region: "Savoie",
        country: "France",
        note: "Face à la gendarmerie — 1er étage, entrée à gauche du bâtiment",
    },
    mapQuery: "1981 Route Royale, 73190 Challes-les-Eaux",
    // Coordonnées Nominatim — 1981 Route Royale, Challes-les-Eaux
    mapEmbedUrl:
        "https://www.openstreetmap.org/export/embed.html?bbox=5.97547%2C45.53105%2C6.00107%2C45.55105&layer=mapnik&marker=45.541046%2C5.98827",
    // Horaires alignés sur le cabinet (site / annuaires)
    hours: [
        { label: "Lundi", value: "14h — 18h" },
        { label: "Mardi", value: "9h–12h & 13h30–18h" },
        { label: "Mercredi", value: "9h — 12h" },
        { label: "Jeudi", value: "9h–12h & 13h30–18h" },
        { label: "Vendredi", value: "9h — 18h" },
        { label: "Samedi", value: "sur rendez-vous" },
        { label: "Dimanche", value: "fermé" },
    ],
};

/** Photos stock self-hébergées (ex-Unsplash) — pas de cookies tiers. */
const stock = (name) => `/images/stock/${name}.webp`;

export const IMAGES = {
    portrait: "/images/joelle-portrait.webp",
    portraitSrcSet:
        "/images/joelle-portrait-360.webp 360w, /images/joelle-portrait-640.webp 640w, /images/joelle-portrait-960.webp 960w, /images/joelle-portrait.webp 1200w",
    consultation: "/images/joelle-consultation.webp",
    cabinet: "/images/joelle-cabinet.webp",
    logoBlack: "/images/logo-joelle-black.webp",
    logoBlackSrcSet:
        "/images/logo-joelle-black-240.webp 240w, /images/logo-joelle-black.webp 404w",
    logoWhite: "/images/logo-joelle-white.webp",
    logoWhiteSrcSet:
        "/images/logo-joelle-white-240.webp 240w, /images/logo-joelle-white.webp 404w",
    massage: stock("massage"),
    foot: "/images/reflexologie-plantaire.webp",
    footSrcSet:
        "/images/reflexologie-plantaire-640.webp 640w, /images/reflexologie-plantaire.webp 900w",
    footCartographie: "/images/foot-cartographie.webp",
    dienChan: "/images/dien-chan.webp",
    dienChanSrcSet:
        "/images/dien-chan-480.webp 480w, /images/dien-chan-720.webp 720w, /images/dien-chan.webp 900w",
    dienChanSoin: "/images/dien-chan-soin.webp",
    tools: stock("tools"),
    room: stock("room"),
    alps: stock("alps"),
    paper: stock("paper"),
    hand: stock("hand"),
    leaf: stock("leaf"),
    face: stock("face"),
    faceSrcSet:
        "/images/stock/face-400.webp 400w, /images/stock/face-640.webp 640w, /images/stock/face.webp 800w",
    portrait2: stock("portrait2"),
    hands_massage: stock("hands-massage"),
    handsMassageSrcSet:
        "/images/stock/hands-massage-480.webp 480w, /images/stock/hands-massage.webp 800w",
    tea: stock("tea"),
    teaSrcSet: "/images/stock/tea-400.webp 400w, /images/stock/tea.webp 600w",
    ceramics: stock("ceramics"),
    herbs: stock("herbs"),
    workshop: stock("workshop"),
    conference: stock("conference"),
    office_wellness: stock("office"),
    footRelax: stock("foot-relax"),
    handDetail: stock("hand-detail"),
    faceLight: stock("face-light"),
    plant: stock("plant"),
    natureWalk: stock("nature-walk"),
    natureWalkSrcSet:
        "/images/stock/nature-walk-480.webp 480w, /images/stock/nature-walk-720.webp 720w, /images/stock/nature-walk.webp 800w",
};

export const PRESTATIONS = [
    {
        slug: "reflexologie-plantaire",
        num: "01",
        name: "Réflexologie plantaire",
        short: "Retour au sol, retour à soi.",
        duration: "60 min",
        price: "60 €",
        color: "sage",
        image: IMAGES.foot,
        forWhom:
            "Adultes cherchant à relâcher les tensions accumulées, retrouver un meilleur sommeil ou accompagner les transitions de vie.",
        principle:
            "La réflexologie plantaire s'appuie sur la cartographie des zones réflexes du pied selon la méthode Eunice Ingham. Chaque zone est reliée à un organe, une glande ou une région du corps. Par des pressions précises, le praticien favorise la circulation de l'énergie et invite le corps à retrouver son propre équilibre.",
        differentiator:
            "Une séance profondément enveloppante, souvent la plus complète pour un premier contact avec la réflexologie.",
        supports: [
            {
                label: "Détente et lâcher-prise",
                detail: "Un relâchement musculaire progressif, la respiration qui s'étire, l'esprit qui redescend d'un cran.",
            },
            {
                label: "Sommeil et récupération",
                detail: "Le système nerveux parasympathique est stimulé — on prépare le terrain d'un meilleur endormissement.",
            },
            {
                label: "Fatigue et manque d'énergie",
                detail: "En travaillant les zones réflexes des glandes, on soutient le retour d'une meilleure vitalité.",
            },
            {
                label: "Tensions musculaires",
                detail: "Nuque, épaules, bas du dos — ces tensions se lisent souvent sur la voûte plantaire.",
            },
            {
                label: "Inconforts liés au stress",
                detail: "Migraines, troubles digestifs légers, boule au ventre : la réflexologie apaise le terrain.",
            },
        ],
    },
    {
        slug: "reflexologie-palmaire",
        num: "02",
        name: "Réflexologie palmaire",
        short: "Une porte discrète, toujours ouverte.",
        duration: "45 min",
        price: "50 €",
        color: "terracotta",
        image: IMAGES.hand,
        forWhom:
            "Personnes réticentes au contact des pieds, femmes enceintes, personnes âgées, ou pour un moment plus court et accessible.",
        principle:
            "Les mains, comme les pieds, portent une cartographie réflexe complète. La réflexologie palmaire est douce, accessible, et parfaite pour un accompagnement régulier ou pour transmettre quelques gestes d'auto-soin.",
        differentiator:
            "Plus courte, très douce, et facile à intégrer dans un accompagnement régulier.",
        supports: [
            {
                label: "Anxiété légère",
                detail: "Une main travaillée quelques minutes suffit parfois à apaiser une montée d'angoisse.",
            },
            {
                label: "Fatigue de la journée",
                detail: "Un rituel court en milieu de journée pour reprendre pied et retrouver de la clarté.",
            },
            {
                label: "Circulation dans les mains",
                detail: "Utile pour les personnes qui utilisent beaucoup leurs mains — bureau, artisanat, musique.",
            },
            {
                label: "Séances plus courtes",
                detail: "45 minutes suffisent, sans avoir à se déchausser. Parfait pour un accompagnement régulier.",
            },
            {
                label: "Auto-soin quotidien",
                detail: "Je vous partage des gestes simples à reprendre chez vous entre deux séances.",
            },
        ],
    },
    {
        slug: "reflexologie-faciale-dien-chan",
        num: "03",
        name: "Réflexologie faciale — Dien Chan",
        short: "Le visage, cartographie vivante.",
        duration: "45 min",
        price: "55 €",
        color: "forest",
        image: IMAGES.dienChanSoin,
        forWhom:
            "Personnes cherchant une approche plus dynamique, ciblée, avec des effets souvent perceptibles dès la séance.",
        principle:
            "Le Dien Chan est une méthode vietnamienne moderne qui utilise plus de 500 points réflexes sur le visage. À l'aide de petits outils en bois ou en métal, la stimulation est précise, énergisante et parfaitement adaptée pour compléter une pratique plantaire ou palmaire.",
        differentiator:
            "Effets rapides, personnalisation forte, adaptée aux personnes actives et pressées.",
        supports: [
            {
                label: "Tensions du visage et de la mâchoire",
                detail: "Bruxisme, serrement, front tendu — le Dien Chan travaille ces zones précisément.",
            },
            {
                label: "Maux de tête liés au stress",
                detail: "En stimulant les points réflexes, on aide à dénouer les tensions responsables des céphalées.",
            },
            {
                label: "Fatigue oculaire",
                detail: "Écrans, lumière, concentration prolongée — le visage porte cette fatigue et peut être soulagé.",
            },
            {
                label: "Congestions saisonnières",
                detail: "Nez, sinus, gorge — quelques points bien travaillés soutiennent le confort respiratoire.",
            },
            {
                label: "Éclat et vitalité",
                detail: "La circulation locale est stimulée : le teint retrouve de l'homogénéité et de la lumière.",
            },
        ],
    },
    {
        slug: "chan-beaute",
        num: "04",
        name: "Chan'Beauté",
        short: "Le soin naturel du visage revisité.",
        duration: "60 min",
        price: "70 €",
        color: "terracotta-deep",
        image: IMAGES.face,
        forWhom:
            "Toutes celles et ceux qui souhaitent prendre soin de leur peau autrement, sans injection, sans produit chimique, avec des gestes naturels et raffinés.",
        principle:
            "Chan'Beauté est une évolution du Dien Chan dédiée au soin du visage. En stimulant les points de tonification, en travaillant les tissus et la circulation, cette séance apporte éclat, souplesse et détente profonde. Un véritable soin naturel du visage, sans produit invasif.",
        differentiator:
            "Une approche plus éditoriale, sensorielle, entre soin esthétique et bien-être profond.",
        supports: [
            {
                label: "Éclat et tonicité de la peau",
                detail: "Un travail complet sur la circulation et les tissus, pour une peau plus lumineuse.",
            },
            {
                label: "Ovale du visage",
                detail: "Un modelage lent et précis qui soutient naturellement la définition de l'ovale.",
            },
            {
                label: "Cernes et fatigue apparente",
                detail: "Drainage doux du contour de l'œil — l'expression se repose et se dénoue.",
            },
            {
                label: "Détente des traits",
                detail: "On relâche ce qu'on ne relâche jamais : mâchoire, front, espace entre les sourcils.",
            },
            {
                label: "Rituel bien-être régulier",
                detail: "Une séance par mois suffit à installer un vrai rituel de soin naturel.",
            },
        ],
    },
];

export const TIMELINE = [
    {
        year: "2018",
        title: "La rencontre",
        text: "Découverte de la réflexologie. Une évidence : accompagner par le geste, l'écoute et le respect du rythme de chacun.",
    },
    {
        year: "2019 → 2020",
        title: "Premières formations",
        text: "Immersion dans la pratique plantaire. Consolidation des fondamentaux anatomiques et énergétiques.",
    },
    {
        year: "2020 → 2021",
        title: "Cursus FFPER",
        text: "Formation certifiée selon la méthode Eunice Ingham auprès de la Fédération Française des Praticiens En Réflexologie.",
    },
    {
        year: "2022",
        title: "Spécialisation Dien Chan",
        text: "Approfondissement de la réflexologie faciale et de ses outils. Une pratique plus ciblée et énergisante.",
    },
    {
        year: "2023",
        title: "Chan'Beauté",
        text: "Formation dédiée au soin naturel du visage. Une évolution éditoriale et sensorielle de la pratique.",
    },
    {
        year: "aujourd'hui",
        title: "Le cabinet",
        text: "Réception au cabinet de Challes-les-Eaux, interventions en entreprise, ateliers et conférences en Savoie.",
    },
];

export const SESSION_STEPS = [
    {
        num: "01",
        title: "Nous prenons le temps d'échanger",
        text: "Avant tout geste, nous parlons. Vos attentes, votre état du jour, vos antécédents. Rien n'est jugé, tout est écouté. Cette étape guide toute la séance.",
    },
    {
        num: "02",
        title: "Installation et choix du protocole",
        text: "Confortablement installé, je vous propose la pratique la plus adaptée : plantaire, palmaire, faciale ou combinée. Vous êtes toujours libre d'orienter la séance.",
    },
    {
        num: "03",
        title: "La séance",
        text: "Environ 45 à 60 minutes de travail précis et enveloppant. Certains parlent, d'autres s'endorment. Il n'y a pas de bonne façon de vivre une séance.",
    },
    {
        num: "04",
        title: "Retour, conseils et suivi",
        text: "Nous prenons quelques minutes ensemble à la fin. Je vous partage mes observations, quelques gestes d'auto-soin, et nous convenons — si besoin — d'un suivi.",
    },
];

export const PROJECTIONS = [
    "Stress",
    "Tensions",
    "Fatigue",
    "Sommeil difficile",
    "Lâcher-prise",
    "Charge mentale",
    "Inconforts saisonniers",
    "Reconnexion",
    "Prendre soin de soi",
    "Récupération",
];

export const FAQ_HOME = [
    {
        q: "Comment se déroule une première séance ?",
        a: "La première séance dure environ 1h. Nous commençons par un échange autour de vos attentes et de votre état du jour. Je vous propose ensuite la pratique la plus adaptée. La séance en elle-même dure 45 à 60 minutes. Nous terminons par un temps de retour et de conseils.",
    },
    {
        q: "Quelle pratique choisir ?",
        a: "Cela dépend de vos préférences, de votre disponibilité et de vos besoins. Si vous ne savez pas, n'hésitez pas à m'appeler quelques minutes : je vous oriente avec plaisir. La plantaire est souvent idéale pour une première découverte.",
    },
    {
        q: "Combien de séances faut-il prévoir ?",
        a: "Une séance ponctuelle apporte souvent déjà un vrai relâchement. Pour un accompagnement plus profond, 3 à 5 séances espacées sont généralement recommandées, mais chaque parcours reste unique.",
    },
    {
        q: "À qui s'adresse la réflexologie ?",
        a: "À tout le monde, ou presque : adultes, enfants, seniors, femmes enceintes (avec quelques précautions). Elle s'adapte à la personne et à ses besoins.",
    },
    {
        q: "Existe-t-il des contre-indications ?",
        a: "Certaines pathologies cardiovasculaires, phlébites, traumatismes récents ou plaies peuvent nécessiter des précautions. Nous en parlons systématiquement avant la séance.",
    },
    {
        q: "La réflexologie remplace-t-elle un traitement médical ?",
        a: "Non. La réflexologie est une pratique complémentaire de bien-être. Elle ne remplace en aucun cas une consultation médicale ni un traitement en cours.",
    },
];

export const FAQ_EXTRA = [
    {
        q: "Comment se passe le paiement ?",
        a: "Espèces, chèque ou virement. Je remets une note d'honoraires sur demande.",
    },
    {
        q: "La séance est-elle prise en charge par la mutuelle ?",
        a: "Certaines mutuelles remboursent partiellement les séances de réflexologie. Renseignez-vous auprès de la vôtre. Je peux vous fournir une note d'honoraires.",
    },
    {
        q: "Y a-t-il du parking ?",
        a: "Oui, un stationnement est possible à proximité du cabinet, à Challes-les-Eaux (1981 Route Royale).",
    },
    {
        q: "Puis-je annuler ou reporter ?",
        a: "Bien sûr. Merci simplement de me prévenir au moins 24h à l'avance quand c'est possible, pour libérer le créneau.",
    },
    {
        q: "Quel est le tarif d'une séance ?",
        a: "Les tarifs indicatifs vont de 35 € (enfants, 30 min) à 75 € (séance combinée, 75 min). La réflexologie plantaire est à 60 € pour 60 minutes. Voir la page Tarifs pour le détail.",
    },
    {
        q: "Où se trouve le cabinet ?",
        a: "Au 1981 Route Royale, 73190 Challes-les-Eaux (Savoie), à proximité d'Aix-les-Bains et de Chambéry. Accès facile, parking à proximité.",
    },
    {
        q: "Proposez-vous des cartes cadeaux ?",
        a: "Oui. Les cartes cadeaux sont personnalisables et valables 1 an. Idéales pour offrir un moment de détente.",
    },
    {
        q: "Intervenez-vous en entreprise ?",
        a: "Oui, en Savoie et alentours : séances express, ateliers et conférences. Sur devis, dans vos locaux ou au cabinet.",
    },
];

export const ZONES = [
    {
        slug: "challes-les-eaux",
        name: "Challes-les-Eaux",
        title: "Réflexologue à Challes-les-Eaux | Joëlle Berthaud",
        h1: "Réflexologue à Challes-les-Eaux",
        description:
            "Cabinet de réflexologie à Challes-les-Eaux (73190). Joëlle Berthaud propose plantaire, palmaire, Dien Chan et Chan'Beauté sur rendez-vous.",
        answer:
            "Joëlle Berthaud reçoit au cabinet situé 1981 Route Royale à Challes-les-Eaux. Réflexologie plantaire, palmaire, faciale Dien Chan et Chan'Beauté. Horaires : lundi 14h–18h, mardi et jeudi 9h–12h & 13h30–18h, mercredi 9h–12h, vendredi 9h–18h, samedi sur rendez-vous.",
        intro:
            "Vous habitez Challes-les-Eaux ou les environs immédiats ? Le cabinet est sur place, facilement accessible, avec un stationnement à proximité.",
        travel: "Cabinet sur place — 1981 Route Royale, 73190 Challes-les-Eaux.",
    },
    {
        slug: "aix-les-bains",
        name: "Aix-les-Bains",
        title: "Réflexologue près d'Aix-les-Bains | Joëlle Berthaud",
        h1: "Réflexologue près d'Aix-les-Bains",
        description:
            "Réflexologue à quelques minutes d'Aix-les-Bains : Joëlle Berthaud vous reçoit à Challes-les-Eaux pour un accompagnement en réflexologie.",
        answer:
            "Habitants d'Aix-les-Bains : Joëlle Berthaud, réflexologue, vous accueille à Challes-les-Eaux (environ 10–15 minutes). Plantaire, palmaire, Dien Chan et Chan'Beauté sur rendez-vous au 06 63 34 03 97.",
        intro:
            "Depuis Aix-les-Bains, le cabinet de Challes-les-Eaux est rapidement accessible en voiture. Un cadre calme, idéal pour déposer le rythme de la semaine.",
        travel: "Environ 10 à 15 minutes depuis Aix-les-Bains.",
    },
    {
        slug: "chambery",
        name: "Chambéry",
        title: "Réflexologue près de Chambéry | Joëlle Berthaud",
        h1: "Réflexologue près de Chambéry",
        description:
            "Réflexologue à proximité de Chambéry : séances à Challes-les-Eaux avec Joëlle Berthaud — stress, sommeil, tensions, lâcher-prise.",
        answer:
            "Depuis Chambéry, rejoignez le cabinet de Joëlle Berthaud à Challes-les-Eaux (environ 15–20 minutes). Réflexologie plantaire, palmaire, Dien Chan et Chan'Beauté, sur rendez-vous.",
        intro:
            "Les personnes venant de Chambéry et de l'agglo trouvent à Challes-les-Eaux un cabinet accessible, sans la densité du centre-ville.",
        travel: "Environ 15 à 20 minutes depuis Chambéry.",
    },
];

export { GUIDES } from "@/lib/guides-data";

export const TARIFS = [
    {
        name: "Réflexologie plantaire",
        duration: "60 min",
        price: 60,
        featured: true,
        note: "La séance la plus complète pour un premier rendez-vous.",
    },
    {
        name: "Réflexologie palmaire",
        duration: "45 min",
        price: 50,
        note: "Une porte d'entrée douce et accessible.",
    },
    {
        name: "Réflexologie faciale — Dien Chan",
        duration: "45 min",
        price: 55,
        note: "Ciblée, énergisante, effets souvent perceptibles rapidement.",
    },
    {
        name: "Enfants (moins de 12 ans)",
        duration: "30 min",
        price: 35,
        note: "Adaptée au rythme et à la sensibilité de l'enfant.",
    },
    {
        name: "Séance combinée",
        duration: "75 min",
        price: 75,
        note: "Combinaison plantaire + Dien Chan pour un accompagnement complet.",
    },
    {
        name: "Chan'Beauté",
        duration: "60 min",
        price: 70,
        wide: true,
        note: "Soin naturel du visage, sensoriel et raffiné.",
    },
];

export const TARIFS_SPECIAUX = [
    { name: "Carte cadeau", detail: "Personnalisable, valable 1 an." },
    { name: "Interventions en entreprise", detail: "Sur devis." },
    { name: "Ateliers & conférences", detail: "Sur devis." },
    { name: "Prestations à domicile", detail: "Sur demande, selon secteur." },
];

/** Note Google globale (tous avis, y compris sans texte). */
export const GOOGLE_RATING = {
    rating: 5,
    count: 14,
    label: "Avis Google",
    url: GOOGLE_MAPS_URL,
};

/** Avis affichés dans les sections (sélection éditoriale). */
export const REVIEWS = [
    {
        author: "Magali Savouré",
        rating: 5,
        quote:
            "Joëlle a su soulager ma lombalgie avec une pression et des gestes aussi techniques que relaxants, en réflexologie plantaire. Sa connaissance de l'énergétique chinoise est un vrai plus, c'est passionnant d'écouter ses explications ! Je la recommande +++ !",
    },
    {
        author: "Aurélie D'Aquilante",
        rating: 5,
        quote:
            "Joëlle a été très douce et à l'écoute de mes besoins. Elle m'a mise à l'aise et en confiance avec une médecine qui ne m'est pas familière. Elle m'a convaincu et c'est avec certitude que je ferai de nouveau appel à ses soins.",
    },
    {
        author: "Stéphanie Ruiz",
        rating: 5,
        quote:
            "Merci à Joëlle pour sa douceur et ce moment de détente. J'ai pu tester la réflexologie faciale (Dien Chan) et palmaire que je ne connaissais pas. Cette séance d'1h m'a permis de me relaxer complètement et d'apaiser les différentes tensions. A refaire très vite.",
    },
];
